import React from 'react';
import FooterCopy from './FooterCopy';

const NoFooter = () => {
  return (
    <footer className="no-footer">
      <div className="no-footer-copy">
        <FooterCopy />
      </div>
    </footer>
  );
};

export default NoFooter;
